var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAuthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#707070;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-333 -306)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(333 306)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(296 307)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M57.486,3.455,49.32.064a.833.833,0,0,0-.639,0L40.514,3.455a.833.833,0,0,0-.514.77V8.346a13.956,13.956,0,0,0,8.685,12.926.833.833,0,0,0,.63,0A13.956,13.956,0,0,0,58,8.346V4.224A.833.833,0,0,0,57.486,3.455ZM56.333,8.346A12.292,12.292,0,0,1,49,19.595,12.292,12.292,0,0,1,41.667,8.346V4.78L49,1.736,56.333,4.78Zm-8.254,2.809,3.582-3.582a.833.833,0,1,1,1.178,1.178l-4.171,4.171a.833.833,0,0,1-1.178,0l-2.329-2.329a.833.833,0,0,1,1.179-1.179Z",
    transform: "translate(0 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthIcon);
export default __webpack_public_path__ + "static/media/authIcon.52984d819a162f6e21ebb4d301c19458.svg";
export { ForwardRef as ReactComponent };